import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'
import '#styles/index.css'
import { makeI18n } from '#i18n/i18n'

const root = document.getElementById('root')

if (root === null) {
  throw new Error('No root element found')
}

import { lateInitializeStore } from '#app/store/root'
import { I18NConfig } from '../i18next-parser.config'

if (VITE_BUILD_WITHOUT_STRICT) {
  console.warn('Strict mode has been disabled.')
}

async function setup(root: HTMLElement) {
  const i18nInit = await makeI18n(I18NConfig.namespace, { kind: 'static', resources: I18NConfig.resources })
  await lateInitializeStore()
  await i18nInit
  ReactDOM.createRoot(root).render(
    VITE_BUILD_WITHOUT_STRICT ? (
      <App />
    ) : (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    ),
  )
}

void setup(root)
